// Do not modify this function

export class MapIntegration {
  iframeId: string;
  constructor(gisMessageHandler, gisURL, iframeId) {
      this.iframeId = iframeId;

      const eventMethod = window.addEventListener ? 'addEventListener' : 'attachEvent';
      const eventer = window[eventMethod];
      const messageEvent = eventMethod === 'attachEvent' ? 'onmessage' : 'message';

      // var url = document.createElement('a');
      // url.href = gisURL;
      // this.bridge.allowOrigin(url.protocol + '//' + url.host);
      // Receive Commands from Map
      eventer(messageEvent, gisMessageHandler);

  }

  // Send Message to Map
  sendUpdateToMap(message) {
      const iFrame: any = document.getElementById(this.iframeId);
      iFrame.contentWindow.postMessage(message, '*');
  }
  // ----------------------------------Send Commands to Map---------------------------------------------------
  /*
      zoomToRequestOnMap  - call this function when map need to be zoom on a request id
    */
  // Do not modify this function
  zoomToRequestOnMap(requestId) { // AR to call this method to zoom to a Grid Survey on Map
      this.sendUpdateToMap({ 'commandOrEventName': 'ZoomToRequest', 'payload': { 'RequestId': requestId } });
  }
  // ----------------------------------Send Commands to Map---------------------------------------------------
}

// Need to add this function in parent application to recieve message from iframe

// gisMessageHandler(message: any) {
//    if (message.commandOrEventName === 'SelectGridSurveys') {
//        this.selectLeakSurvey(message.payload);
//    }
//    if (message.commandOrEventName === 'UnSelectGridSurveys') {
//        this.selectLeakSurvey(message.payload);
//    }
//    if (message.commandOrEventName === 'ClearLeakSurveysFromMap') {
//        this.selectLeakSurvey([]);
//    }
// }
